// SPDX-FileCopyrightText: 2026 Povl Filip Sonne-Frederiksen
//
// SPDX-License-Identifier: GPL-3.0-or-later

import { TextLink } from '../TextLink';
import styles from './ElementChip.module.css';

export interface ElementChipProps {
  /** "Væg · Stue", from `elementsSummary`. */
  summary: string;
  /** Extra facts, already formatted ("Tykkelse 0,20 m"). */
  details: readonly string[];
  guid: string;
  onClear: () => void;
}

/**
 * The building element picked in the 3D model (frontend-r22.27): what it
 * is, its storey, a few measures and its GUID, under the Ground's tool
 * row. "Ryd" (or a click on nothing) drops the selection.
 */
export function ElementChip({ summary, details, guid, onClear }: ElementChipProps) {
  return (
    <div className={styles.chip} role="status" aria-label="Valgt bygningsdel">
      <span className={styles.dot} aria-hidden="true" />
      <span className={styles.summary}>{summary}</span>
      {details.map((d) => (
        <span key={d} className={styles.detail}>
          {d}
        </span>
      ))}
      <span className={styles.guid} title={guid}>
        {guid.slice(0, 8)}
      </span>
      <TextLink size="sm" onClick={onClear}>
        Ryd
      </TextLink>
    </div>
  );
}
